export default __webpack_public_path__ + "static/media/ysse.840b503d.png";